export default "__VITE_ASSET__Cxfus09B__"